import React, { useEffect, useState } from 'react';
import { formateENGBManually, formateDate } from '../../../utils/utils';
import Calendar from '../../Calendar/Calendar';
import MobilePopUp from '../../MobilePopUp/MobilePopUp';
import { updateENACH } from '../../../store/actions/enachUpdate';
import { useDispatch } from 'react-redux';

const PATCHING_NET_BANKING = "NET_BANKING";
const PATCHING_UPI_CARD = "UPI_CARD";

const EnachDetails = (props) => {
  const { setEnach, setShow, pn } = props;
  const [patchingOption, setPatchingOption] = useState(PATCHING_NET_BANKING);
  const [inputValue, setInputValue] = useState({
    umrNo: "",
    accountNo: "",
    proposalNo: pn,
    bankName: "",
    siamount: "",
    txAmount: "",
    accountHolderName: "",
    approvedDate: "",
    paymentMethodType: "",
    mandateId: "",
    cardMaskedValue: "",
  })
  const [dateInput, setDateInput] = useState()
  const [isValid, setIsValid] = useState(false);
  const [date, ShowDate] = useState(false);

  const [showByDateRangeFrom, setDateRangeFrom] = useState(false);
  const [showByDateRangeTo, setDateRangeTo] = useState(false);
  const [startTimestamp, setStartTimeStamp] = useState('');
  const [endTimestamp, setEndTimestamp] = useState('');
  const [futureStartDate, setFutureStartDate] = useState('');

  const isNetBanking = patchingOption === PATCHING_NET_BANKING;

  const dispatch = useDispatch();
  useEffect(() => {
    const commonValid =
      pn &&
      inputValue.accountHolderName &&
      inputValue.approvedDate &&
      startTimestamp &&
      endTimestamp;

    if (isNetBanking) {
      setIsValid(Boolean(
        commonValid &&
        inputValue.umrNo &&
        inputValue.accountNo &&
        inputValue.bankName
      ));
    } else {
      setIsValid(Boolean(
        commonValid &&
        inputValue.paymentMethodType &&
        inputValue.mandateId
      ));
    }
  }, [inputValue, pn, startTimestamp, endTimestamp, isNetBanking])

  useEffect(() => {
    if (startTimestamp > endTimestamp) {
      setEndTimestamp('')
    }
  }, [startTimestamp, endTimestamp])

  const padTo2Digits = (num) => {
    return num.toString().padStart(2, "0");
  };
  const formatDate = (date) => {
    return [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join("-");
  };

  const changeHandler = (value, name) => {
    if (name === 'bankName' || name === 'accountHolderName') {
      const letters = /^[a-zA-Z ]*$/;
      if (letters.test(value) || value === "") {
        setInputValue({
          ...inputValue,
          [name]: value
        })
      }
    }
    else if (name === "umrNo" || name === "mandateId") {
      const letters = /^[a-zA-Z0-9]*$/
      if (letters.test(value) || value === "") {
        setInputValue({
          ...inputValue,
          [name]: value
        });
      }
    }
    else if (name === 'accountNo' || name == 'txAmount' || name === 'siamount') {
      const letters = /^[0-9]*$/
      if (letters.test(value) || value === "") {
        setInputValue({
          ...inputValue,
          [name]: value
        });
      }
    }
    else if (name === "cardMaskedValue") {
      setInputValue({
        ...inputValue,
        [name]: value
      });
    }
    else if (name === "paymentMethodType") {
      setInputValue({
        ...inputValue,
        paymentMethodType: value,
        cardMaskedValue: value === "CARD" ? inputValue.cardMaskedValue : "",
      });
    }
    else if (name === "approvedDate") {
      const newDate = formateENGBManually(new Date(value))
      setInputValue({
        ...inputValue,
        [name]: formatDate(new Date(value))
      })
      setDateInput({
        ['approvedDate']: newDate,
      })
    }
  }

  const handlePatchingOptionChange = (option) => {
    setPatchingOption(option);
    setIsValid(false);
  }

  const resetForm = () => {
    setInputValue({
      umrNo: "",
      accountNo: "",
      proposalNo: "",
      bankName: "",
      siamount: "",
      txAmount: "",
      accountHolderName: "",
      approvedDate: "",
      paymentMethodType: "",
      mandateId: "",
      cardMaskedValue: "",
    })
    setStartTimeStamp('')
    setEndTimestamp('')
  }

  const updateEnach = (e) => {
    e.preventDefault();
    let startTimeDate = formateENGBManually(new Date(startTimestamp))
    let endTimeDate = formateENGBManually(new Date(endTimestamp))

    let data = {
      patchingOption,
      proposalNo: props.pn,
      accountHolderName: inputValue.accountHolderName,
      approvedDate: dateInput.approvedDate,
      mandateStartDate: startTimeDate,
      mandateEndDate: endTimeDate,
    }

    if (isNetBanking) {
      data.accountNo = inputValue.accountNo;
      data.bankName = inputValue.bankName;
      data.siamount = inputValue.siamount;
      data.txAmount = inputValue.txAmount;
      data.umrNo = inputValue.umrNo;
    } else {
      data.paymentMethodType = inputValue.paymentMethodType;
      data.mandateId = inputValue.mandateId;
      if (inputValue.paymentMethodType === "CARD" && inputValue.cardMaskedValue) {
        data.cardMaskedValue = inputValue.cardMaskedValue;
      }
    }

    dispatch(updateENACH(data, (res) => {
      if (res.data.status === "OK") {
        setShow(false)
        setEnach({ proposalNumber: '' })
      }
    }))
    resetForm()
  }
  const calendarFunction = () => {
    ShowDate(true);
  };
  const futureDate = (sd) => {
    const currentDate = new Date(sd);
    const newDate = new Date(currentDate);
    const futureStartDate = newDate.setDate(currentDate.getDate() + 1);
    setFutureStartDate(futureStartDate)
  }

  return (
    <>
      <div className="main_container">
        
        <div className="list_enach list_enach_full">
          <label>Patching Option<span style={{ color: "red" }}>*</span></label>
          <div className="enach_patch_options">
            <label className="enach_patch_option">
              <input
                type="radio"
                name="patchingOption"
                value={PATCHING_UPI_CARD}
                checked={patchingOption === PATCHING_UPI_CARD}
                onChange={() => handlePatchingOptionChange(PATCHING_UPI_CARD)}
              />
              UPI/Credit/Debit Mandate Patching
            </label>
            <label className="enach_patch_option">
              <input
                type="radio"
                name="patchingOption"
                value={PATCHING_NET_BANKING}
                checked={patchingOption === PATCHING_NET_BANKING}
                onChange={() => handlePatchingOptionChange(PATCHING_NET_BANKING)}
              />
              NB/Credit/Debit Mandate Patching
            </label>
          </div>
        </div>

        {isNetBanking ? (
          <>
            <div className="list_enach">
              <label>Enter URM No.<span style={{ color: "red" }}>*</span></label>
              <input
                onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
                value={inputValue.umrNo}
                className="value"
                type="text"
                name="umrNo"
              />
            </div>

            <div className="list_enach">
              <label> Enter Bank Name<span style={{ color: "red" }}>*</span></label>
              <input
                onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
                value={inputValue.bankName}
                className="value"
                type="text"
                name="bankName"
              />
            </div>

            <div className="list_enach">
              <label> Enter SI Amount <span style={{ color: '#ccc', 'fontSize': "12px" }}>(optional)</span></label>
              <input
                onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
                value={inputValue.siamount}
                className="value"
                type="text"
                name="siamount"
              />
            </div>

            <div className="list_enach">
              <label>Enter Account No.<span style={{ color: "red" }}>*</span></label>
              <input
                onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
                value={inputValue.accountNo}
                className="value"
                type="text"
                name="accountNo"
              />
            </div>

            <div className="list_enach">
              <label>Enter Transaction amount <span style={{ color: '#ccc', 'fontSize': "12px" }}>(optional)</span></label>
              <input
                onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
                value={inputValue.txAmount}
                className="value"
                type="text"
                name="txAmount"
              />
            </div>
          </>
        ) : (
          <>
            <div className="list_enach">
              <label>Payment Method Type<span style={{ color: "red" }}>*</span></label>
              <select
                className="value"
                name="paymentMethodType"
                value={inputValue.paymentMethodType}
                onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
              >
                <option value="">Select</option>
                <option value="UPI">UPI</option>
                <option value="CARD">CARD</option>
              </select>
            </div>

            <div className="list_enach">
              <label>Enter Mandate Id<span style={{ color: "red" }}>*</span></label>
              <input
                onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
                value={inputValue.mandateId}
                className="value"
                type="text"
                name="mandateId"
              />
            </div>

            {inputValue.paymentMethodType === "CARD" && (
              <div className="list_enach">
                <label>Card Masked Value <span style={{ color: '#ccc', 'fontSize': "12px" }}>(optional)</span></label>
                <input
                  onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
                  value={inputValue.cardMaskedValue}
                  className="value"
                  type="text"
                  name="cardMaskedValue"
                />
              </div>
            )}
          </>
        )}

        <div className="list_enach">
          <label>Enter Proposal No.<span style={{ color: "red" }}>*</span></label>
          <input
            className="value"
            defaultValue={props.pn}
            type="text"
            name="proposalNo"
            disabled
          />
        </div>

        <div className="list_enach">
          <label>Enter Account Holder Name<span style={{ color: "red" }}>*</span></label>
          <input
            onChange={(e) => { changeHandler(e.target.value, e.target.name) }}
            value={inputValue.accountHolderName}
            className="value"
            type="text"
            name="accountHolderName"
          />
        </div>

        <div className="list_enach">
          <label>Approve Date<span style={{ color: "red" }}>*</span></label>
          <input
            defaultValue={inputValue.approvedDate}
            className="value"
            type="text"
            name="approvedDate"
            onClick={calendarFunction}
          />
        </div>
        <>
          <div className="list_enach">
            <label>Mandate Start Date<span style={{ color: "red" }}>*</span></label>
            <div
              className="value"
              onClick={() => {
                setDateRangeFrom(true);
                setDateRangeTo(false);
              }}
            >
              <span
                className={`date-value ${startTimestamp ? "active" : ""
                  }`}
              >
                {startTimestamp
                  ? formateDate(new Date(startTimestamp))
                  : ""}
              </span>
              <span className="calendar_icon"></span>
            </div>

          </div>
          <div className="list_enach ">
            <label>Mandate End Date<span style={{ color: "red" }}>*</span></label>
            <div
              className={`value ${startTimestamp.length == 0 && `dateDisable`}`}
              onClick={() => {
                if (startTimestamp.length !== 0) {
                  setDateRangeTo(true);
                }
                else {
                  setDateRangeTo(false);
                }
                setDateRangeFrom(false);
              }}
              disabled={startTimestamp.length !== 0 ? false : true}

            >
              <span
                className={`date-value ${endTimestamp ? "active" : ""
                  }`}
              >
                {startTimestamp.length !== 0 && (endTimestamp
                  ? formateDate(new Date(endTimestamp))
                  : "")

                }
              </span>
              <span className="calendar_icon"></span>
            </div>

          </div>
        </>

      </div>
      <div className='op-btn'>
        <button
          disabled={!isValid}
          className={` ${isValid ? "searchbt" : "searchbtdisabled "}`}
          onClick={updateEnach}
        >
          UPDATE
        </button>
      </div>
      {date && (
        <MobilePopUp
          hideCloseBtn={true}
          removeHeader={true}
          cssClass="daterange-mobilepopup"
        >
          <Calendar
            maxDate={new Date()}
            onCancel={() => {
              ShowDate(false);
            }}
            onApply={(sd) => {
              changeHandler(sd, "approvedDate");
              ShowDate(false);
            }}
          />
        </MobilePopUp>
      )}
      {/* --- date range --- */}
      <>
        {showByDateRangeFrom && (
          <MobilePopUp
            hideCloseBtn={true}
            removeHeader={true}
            cssClass="daterange-mobilepopup"
          >
            <Calendar
              dob={startTimestamp}
              maxDate={'false'}
              onCancel={() => {
                setDateRangeFrom(false);
                setStartTimeStamp("");
                setEndTimestamp("");
              }}
              onApply={(sd) => {
                setDateRangeFrom(false);
                setStartTimeStamp(sd);
                futureDate(sd)
              }
              }
            />
          </MobilePopUp>
        )}
        {showByDateRangeTo && (
          <MobilePopUp
            hideCloseBtn={true}
            removeHeader={true}
            cssClass="daterange-mobilepopup"
          >
            <Calendar
              dob={futureStartDate}
              minDate={futureStartDate}
              maxDate={'false'}
              onCancel={() => {
                setDateRangeTo(false);
                setEndTimestamp("");
              }}
              onApply={(sd) => {
                setDateRangeTo(false);
                setEndTimestamp(sd);
              }}
            />
          </MobilePopUp>
        )}
      </>
    </>
  )
}

export default EnachDetails;